import { AppBar, Button, Toolbar } from '@mui/material';
import logo from '../assets/logo.png';
import LogoutIcon from '@mui/icons-material/Logout';
import { overlayButtonSx } from './overlayButtonSx';

const AppBarSettings = ({
    handleLogOut,
    navigateTo
    }: {
    handleLogOut: () => void
    navigateTo: () => void
}) => {

    return (
        <AppBar position="static" style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}>
        <Toolbar style={{ display: 'flex', justifyContent: 'space-between', gap: 8, minHeight: 56 }}>
        <Button
            onClick={navigateTo}
            variant="text"
            color="inherit"
            aria-label="Open overlay"
            sx={{ ...overlayButtonSx, minWidth: 0 }}
        >
         <img src={logo} alt="YouCould" style={{ height: 40, width: 'auto' }} />
         </Button>
          <Button
              onClick={handleLogOut}
              variant="text"
              color="inherit"
              startIcon={<LogoutIcon />}
              sx={overlayButtonSx}
          >
              Log Out
          </Button>
        </Toolbar>
      </AppBar>
    );}

export default AppBarSettings;
